import React, { useState, useEffect } from 'react';
import api from '../services/api';

function Translations() {
  const [translations, setTranslations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showBulkImport, setShowBulkImport] = useState(false);
  const [file, setFile] = useState(null);
  const [importResult, setImportResult] = useState(null);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    fetchTranslations();
  }, []);

  const fetchTranslations = async () => {
    try {
      setLoading(true);
      const response = await api.get('/admin/translations');
      setTranslations(response.data);
    } catch (error) {
      console.error('Failed to fetch translations:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleBulkImport = async (e) => {
    e.preventDefault();
    if (!file) {
      setMessage({ type: 'error', text: 'Please select a CSV file' });
      return;
    }

    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await api.post('/admin/translations/bulk', formData);
      setImportResult(response.data);
      setMessage({ type: 'success', text: `Imported ${response.data.imported} translations!` });
      setFile(null);
      setShowBulkImport(false);
      fetchTranslations();
    } catch (error) {
      setMessage({ type: 'error', text: error.message });
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>
      </div>
    );
  }

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Translations</h1>
        <p className="page-subtitle">Manage translations for all lexemes</p>
      </div>

      {message && (
        <div className={`alert ${message.type === 'success' ? 'alert-success' : 'alert-error'}`}>
          {message.text}
        </div>
      )}

      <div style={{ marginBottom: '20px', display: 'flex', gap: '12px' }}>
        <button
          className="btn btn-primary"
          onClick={() => setShowBulkImport(!showBulkImport)}
        >
          {showBulkImport ? 'Cancel' : '📤 Bulk Import CSV'}
        </button>
        <button className="btn btn-secondary">+ Add Translation</button>
      </div>

      {showBulkImport && (
        <div className="card" style={{ marginBottom: '20px' }}>
          <h3 style={{ marginBottom: '16px' }}>Bulk Import from CSV</h3>
          
          <div className="alert alert-info" style={{ marginBottom: '16px' }}>
            <strong>CSV Format:</strong> global_index, concept_key, language_code, text, example
          </div>

          <form onSubmit={handleBulkImport}>
            <div className="form-group">
              <label className="form-label">Upload CSV File</label>
              <div className="file-upload">
                <input
                  type="file"
                  accept=".csv"
                  onChange={handleFileChange}
                  style={{ display: 'none' }}
                  id="csv-upload"
                />
                <label htmlFor="csv-upload" style={{ cursor: 'pointer' }}>
                  <div style={{ fontSize: '48px', marginBottom: '8px' }}>📄</div>
                  <div>{file ? file.name : 'Click to select CSV file'}</div>
                </label>
              </div>
            </div>

            <button
              type="submit"
              className="btn btn-primary"
              disabled={!file}
            >
              Import Translations
            </button>
          </form>

          {importResult && (
            <div style={{ marginTop: '16px', padding: '16px', background: 'rgba(126, 63, 242, 0.1)', borderRadius: '8px' }}>
              <h4>Import Results:</h4>
              <ul style={{ marginTop: '8px', marginLeft: '20px' }}>
                <li>Total rows: {importResult.total_rows}</li>
                <li>Successfully imported: {importResult.imported}</li>
                <li>Errors: {importResult.errors}</li>
              </ul>
            </div>
          )}
        </div>
      )}

      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <th>Lexeme</th>
              <th>Language</th>
              <th>Translation</th>
              <th>Example</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {translations.length === 0 ? (
              <tr>
                <td colSpan="5" style={{ textAlign: 'center', padding: '40px' }}>
                  No translations found. Use bulk import to add translations.
                </td>
              </tr>
            ) : (
              translations.slice(0, 50).map((trans) => (
                <tr key={trans._id}>
                  <td>
                    {trans.lexeme_id?.concept_key || 'N/A'} 
                    <span style={{ color: 'rgba(243, 234, 255, 0.5)', marginLeft: '8px' }}>
                      #{trans.lexeme_id?.global_index}
                    </span>
                  </td>
                  <td>{trans.language_code}</td>
                  <td><strong>{trans.text}</strong></td>
                  <td style={{ fontSize: '13px', color: 'rgba(243, 234, 255, 0.7)' }}>
                    {trans.example || '-'}
                  </td>
                  <td>
                    <button className="btn-icon" title="Edit">✏️</button>
                    <button className="btn-icon" title="Delete">🗑️</button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Translations;

